import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { DataTransferService } from './data-transfer.service';
import { GlobalService } from 'src/app/global.service';
import { IcustomerService } from '../icustomer.service';
import { MatDialog } from '@angular/material/dialog';
import { IcustomerLimitErrorComponent } from '../icustomer-limit-error/icustomer-limit-error.component';
import { BoothChangeForOrderComponent } from '../booth-change-for-order/booth-change-for-order.component';
import { UserIsActiveService } from 'src/app/services/user-is-active.service';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';
import { IcustomerCardPreviewComponent } from '../icustomer-card-preview/icustomer-card-preview.component';
import { IcustomerPersonalDetailsComponent } from 'src/app/icustomer-personal-details/icustomer-personal-details.component';
import { resolve } from 'url';
import { IcustomerConfirmOrderComponent } from '../icustomer-confirm-order/icustomer-confirm-order.component';
@Component({
  selector: 'app-icustomer-order-register',
  templateUrl: './icustomer-order-register.component.html',
  styleUrls: ['./icustomer-order-register.component.scss']
})
export class IcustomerOrderRegisterComponent implements OnInit {

  product_form_dict: any = { 'total_price_per_order': 0 };
  product_list: any;
  session_list: any;
  final_price: any;
  total_days_in_next_month: number;
  today: any;
  monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  next_month_value_in_number: number;
  next_month_start_date_in_string: any;
  business_details: any;
  pincode: any;
  product_availability: any;
  icustomer_id: any = null;
  icustomer_verified = false;
  icustomer_detail: Object;
  milk_limit: any;
  total_quantity: any = 0;
  old_employee_product_list: any;
  wallet_balance = 0;
  icustomer_type_id: any;
  showerror: boolean = false;
  icustomer_code: any = null;
  icustomer_mobile: any = null;
  is_counter_selected: boolean = false;
  counter_list: any;
  collection_center: any = [];
  logged_user_befere_select_counter: any;
  sale_group_data: any;
  login_users: any;
  total_amount_in_counter: any;
  total_amount_used_via_wallet: any;
  counter_name: any;
  today_date_time: any = new Date();
  future_order: any;
  month_and_year: any = null;
  selected_index: any = null;
  selected_date: string;
  total_days_in_month: number;
  product_form_dict_for_future_order: {};
  business_details_for_future: any;
  current_month_for_future_order_check = new Date().getMonth() + 1;
  current_year_for_future_order_check = new Date().getFullYear();
  disable_button = false;
  total_booth_count: any;
  is_deteted = true;
  next_month_order_avaliable: any;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  order_expiry_date: any;
  show_form: boolean = true;

  constructor(private httpService: HttpService, private dataTransfer: DataTransferService, private global: GlobalService, private service: IcustomerService,
    public dialog: MatDialog, private userIsActiveService: UserIsActiveService) {

    this.global.set_master_page_title = 'Customer Order';
    let today = new Date();
    this.today = today.toISOString().split('T')[0];
    this.httpService.serveUnActiveCounter().subscribe((data) => {
      console.log(data);
      if (data === 'counter already selected') {
        this.is_counter_selected = true;
        setTimeout(() => document.getElementById('customer_code').focus(), 500);
        this.serveCounteOrders();
      } else {
        this.counter_list = data['counter_data'];
        this.collection_center = Object.keys(this.counter_list);
        this.logged_user_befere_select_counter = data['logged_users'];
      }
    }, (error) => {
      console.error(error);
      this.userIsActiveService.checkUserIsActive();
    });
  }

  enterKeyCalled(session_id, product_index) {
    if (session_id === 2 && product_index + 1 === this.product_list.length) {
      if (document.getElementById('confirm_button') !== null) {
        document.getElementById('confirm_button').focus();
      }
    } else {
      if (session_id === 1) {
        session_id = 2;
      } else {
        session_id = 1;
        product_index = product_index + 1;
      }
      if (!this.product_availability[session_id][this.product_list[product_index]['product_id']]) {
        this.enterKeyCalled(session_id, product_index);
      } else {
        let next_element_id = session_id + '_' + product_index;
        if (document.getElementById(next_element_id) !== null) {
          document.getElementById(next_element_id).focus();
        }
      }
    }
  }

  leftArrowKeyCalled(session_id, product_index) {
    if (session_id === 1 && product_index === 0) {
    } else {
      if (session_id === 1) {
        session_id = 2;
        product_index -= 1;
      } else {
        session_id = 1;
      }
      let session_obj = this.session_list.filter((element) => {
        return element.id === session_id;
      });
      if (!this.product_availability[session_id][this.product_list[product_index]['product_id']]) {
        this.leftArrowKeyCalled(session_id, product_index);
      } else {
        let next_element_id = session_id + '_' + product_index;
        if (document.getElementById(next_element_id) !== null) {
          document.getElementById(next_element_id).focus();
        }
      }
    }
  }

  upArrowKeyCalled(session_id, product_index) {
    if (product_index === 0) {
    } else {
      product_index -= 1;
      if (!this.product_availability[session_id][this.product_list[product_index]['product_id']]) {
        this.upArrowKeyCalled(session_id, product_index);
      } else {
        let next_element_id = session_id + '_' + product_index;
        if (document.getElementById(next_element_id) !== null) {
          document.getElementById(next_element_id).focus();
        }
      }
    }
  }

  rightArrowKeyCalled(session_id, product_index) {
    if (session_id === 2 && product_index + 1 === this.product_list.length) {
      if (document.getElementById('confirm_button') !== null) {
        document.getElementById('confirm_button').focus();
      }
    } else {
      if (session_id === 1) {
        session_id = 2;
      } else {
        session_id = 1;
        product_index = product_index + 1;
      }
      if (!this.product_availability[session_id][this.product_list[product_index]['product_id']]) {
        this.rightArrowKeyCalled(session_id, product_index);
      } else {
        let next_element_id = session_id + '_' + product_index;
        if (document.getElementById(next_element_id) !== null) {
          document.getElementById(next_element_id).focus();
        }
      }
    }
  }

  downArrowKeyCalled(session_id, product_index) {
    if (product_index + 1 === this.product_list.length) {
      if (document.getElementById('confirm_button') !== null) {
        document.getElementById('confirm_button').focus();
      }
    } else {
      product_index += 1;
      if (!this.product_availability[session_id][this.product_list[product_index]['product_id']]) {
        this.downArrowKeyCalled(session_id, product_index);
      } else {
        let next_element_id = session_id + '_' + product_index;
        console.log(next_element_id);
        if (document.getElementById(next_element_id) !== null) {
          document.getElementById(next_element_id).focus();
        }
      }
    }
  }

  eventEmitOnInput(session_id, product_index, event) {
    console.log(event.keyCode);
    let key_code = event.keyCode;
    if (key_code === 13) {
      this.enterKeyCalled(session_id, product_index);
    } else if (key_code === 37) {
      this.leftArrowKeyCalled(session_id, product_index);
    } else if (key_code === 38) {
      this.upArrowKeyCalled(session_id, product_index);
    } else if (key_code === 39) {
      this.rightArrowKeyCalled(session_id, product_index);
    } else if (key_code === 40) {
      this.downArrowKeyCalled(session_id, product_index);
    }
  }

  eventEmitClickedOnCustmerCode(event, data_from) {
    let key_code = event.keyCode;
    if (key_code === 13) {
      this.getIcustomerDetails(data_from);
    } else if (key_code === 39) {
      document.getElementById('customer_phone_number').focus();
    }
  }

  eventEmitClickedOnCustmerPhone(event, data_from) {
    console.log(event);
    let key_code = event.keyCode;
    if (key_code === 13) {
      this.getIcustomerDetails(data_from);
    } else if (key_code === 37) {
      document.getElementById('customer_code').focus();
    }
  }

  serveCounteOrders() {
    this.httpService.serveIcustomerCounteOrders().subscribe((data) => {
      console.log(data);
      this.sale_group_data = data['sale_data'];
      this.login_users = data['login_users'];
      this.total_amount_in_counter = data['total_quantity'];
      this.total_amount_used_via_wallet = data['total_amount_used_via_wallet'];
      this.counter_name = this.login_users[0]['counter_name'];
      this.total_booth_count = data['total_booth_count'];
    }, (error) => {
      console.error(error);
    });
  }

  counterClicked(counter_id) {
    let data_dict = {
      'counter_id': counter_id
    };
    this.httpService.assignCounterToEmployee(data_dict).subscribe((data) => {
      console.log(data);
      if (!data['is_taken']) {
        this.is_counter_selected = true;
        setTimeout(() => document.getElementById('customer_code').focus(), 500);
        this.serveCounteOrders();
      } else {
        alert('Selected counter is already taken by' + data['taken_by']);
        return false;
      }
    }, (error) => {
      this.is_counter_selected = false;
      console.error(error);
    });
  }

  getIcustomerDetails(data_from = null) {
    if (data_from !== null) {
      if (data_from === 'code') {
        if (this.icustomer_code == null || this.icustomer_code === '') {
          alert('Please enter a custmer code to Search for');
          return false;
        }
      } else {
        if (this.icustomer_mobile == null || this.icustomer_mobile === '') {
          alert('Please enter a phone number to Search for');
          return false;
        }
      }
    }
    let data_dict = { 'icustomer_number': this.icustomer_mobile, 'icustomer_code': this.icustomer_code };
    this.httpService.checkIcustomerDetails(data_dict).subscribe((data) => {
      console.log('customer details', data);
      if (data['found']) {
        this.icustomer_verified = true;
        this.icustomer_detail = data;
        this.icustomer_id = data['icustomer_id'];
        // this.service.set_icustomer_data = data['icustomer_id']
        this.final_price = null;
        this.total_days_in_next_month = null;
        this.milk_limit = null;
        this.total_quantity = 0;
        this.checkNextMonthOrder();
        this.serveProductList();
      } else {
        if (this.icustomer_code !== null) {
          alert(String(this.icustomer_code) + ' is not a valid Customer code. Please Check');
          this.icustomer_code = null;
        } else {
          alert(String(this.icustomer_mobile) + ' is not a valid Phone number. Please Check');
          this.icustomer_mobile = null;
        }

      }
    }, (error) => {
      console.log(error);
    });
  }

  serveBusinessDetails() {
    const data_dict = {
      'icustomer_id': this.icustomer_id,
      'from': 'portal'
    };
    this.httpService.serveCustomerBusinessDetails(data_dict).subscribe((data) => {
      console.log(data);
      this.business_details = data;

    }, (error) => {
      console.error(error);
    });
  }


  async serveProductList() {
    const data_dict = {
      'icustomer_id': this.icustomer_id,
      'from': 'portal'
    };
    this.httpService.serveProductListForICustomer(data_dict).subscribe((data) => {
      console.log(data);
      this.product_list = data['product_list'];
      this.session_list = data['session_list'];
      this.product_availability = data['product_availability'];
      this.milk_limit = data['milk_limit'];
      this.old_employee_product_list = data['old_employee_product_list'];
      this.wallet_balance = data['wallet_balance'];
      this.order_expiry_date = data['order_expiry_date'];
      console.log(this.order_expiry_date);
      const service_dict = {
        'icustomer_type_id': data['icustomer_type_id'],
        'old_employee_products': this.old_employee_product_list
      };
      this.icustomer_type_id = data['icustomer_type_id'];
      this.httpService.serveLastMonthOrderForICustomer(data_dict).subscribe((last_date_data) => {
        console.log(last_date_data);
        this.serveBusinessDetails();
        this.pincode = last_date_data['pincode'];
        let last_date_product_data = last_date_data['last_date_product_data'];
        if (last_date_data['is_exists']) {
          let date = new Date();
          if (last_date_data['next_date_from_last_date'] < this.today) {
            date = new Date();
          } else {
            date = new Date(last_date_data['next_date_from_last_date']);
          }
          let next_month_start_date = new Date(date.setMonth(date.getMonth() + 1, 1));
          this.next_month_start_date_in_string = next_month_start_date.toISOString().split('T')[0];
          this.next_month_value_in_number = next_month_start_date.getMonth();
          this.total_days_in_next_month = new Date(next_month_start_date.getFullYear(), next_month_start_date.getMonth() + 1, 0).getDate();

        } else {
          let today = new Date();
          let next_month_start_date = new Date(today.setMonth(today.getMonth() + 1, 1));
          this.next_month_start_date_in_string = next_month_start_date.toISOString().split('T')[0];
          this.next_month_value_in_number = next_month_start_date.getMonth();
          this.total_days_in_next_month = new Date(next_month_start_date.getFullYear(), next_month_start_date.getMonth() + 1, 0).getDate();
        }
        if (new Date().getDate() > this.order_expiry_date[this.next_month_value_in_number + 1]['date']) {
          this.icustomer_verified = false;
          this.total_quantity = 0;
          this.icustomer_code = null;
          this.icustomer_mobile = null;
          this.serveCounteOrders();
          window.scrollTo(0, 0);
          setTimeout(() => document.getElementById('customer_code').focus(), 500);
          this.disable_button = false;
          alert('அடுத்த மாதத்துக்கு ஆர்டர் செய்யும் நேரம் முடிந்தது ');
          return false
          // alert('Last date for ' + String(this.monthNames[this.next_month_value_in_number]) + ' order is ' + String(this.monthNames[new Date().getMonth()]) + ' ' + String(this.order_expiry_date[this.next_month_value_in_number + 1]['date'] + '.'));

        }
        this.product_form_dict = {};
        this.product_form_dict['product'] = {};
        this.product_form_dict['total_price_per_product_per_day'] = {};
        this.product_form_dict['total_price_per_product_per_month'] = {};
        this.product_form_dict['total_price_per_session'] = {};
        this.product_form_dict['total_quantity_per_session'] = {};
        this.product_form_dict['total_price_per_order'] = 0;
        data['session_list'].forEach(session_element => {
          this.product_form_dict['product'][session_element.id] = {};
          this.product_form_dict['total_price_per_session'][session_element.id] = 0;
          this.product_form_dict['total_quantity_per_session'][session_element.id] = 0;
          data['product_list'].forEach(product_element => {
            this.product_form_dict['product'][session_element.id][product_element.product_id] = {
              'quantity': null,
              'price': 0
            };
            // this.product_form_dict['total_price_per_product_per_day'][product_element.product_id] = 0;
            this.product_form_dict['total_price_per_product_per_month'][product_element.product_id] = 0;
          });
        });
        console.log(this.product_form_dict);
        setTimeout(() => document.getElementById('1_0').focus(), 500);
        this.getHistroy();
      }, (error) => {
        console.error(error);
      });
    }, (error) => {
      console.error(error);
    });
  }


  productQuantityChanged(session_id, product_id, product_price) {
    // calculate overall quatitity
    console.log('function called');
    let temp_quantity = this.product_form_dict['product'][session_id][product_id]['quantity'];
    if (temp_quantity !== '') {
      this.product_form_dict['product'][session_id][product_id]['quantity'] = parseInt(this.product_form_dict['product'][session_id][product_id]['quantity']);
    } else {
      this.product_form_dict['product'][session_id][product_id]['quantity'] = null;
    }
    this.total_quantity = 0;
    this.session_list.forEach(session_element => {
      this.product_list.forEach(product_element => {
        this.total_quantity += this.product_form_dict['product'][session_element.id][product_element.product_id]['quantity'] * product_element.product_quantity;
      });
    });
    console.log(this.product_form_dict['product'][session_id][product_id]['quantity']);
    this.total_quantity = this.total_quantity / 1000;
    let quantity = this.product_form_dict['product'][session_id][product_id]['quantity'];
    this.product_form_dict['product'][session_id][product_id]['price'] = quantity * product_price;
    // add the product session based total price
    let total_cost = 0;
    this.session_list.forEach(session_element => {
      total_cost += this.product_form_dict['product'][session_element.id][product_id]['price'];
    });
    this.product_form_dict['total_price_per_product_per_month'][product_id] = this.total_days_in_next_month * total_cost;
    // add the total product price date wise
    this.product_form_dict['total_price_per_order'] = 0;
    this.product_list.forEach(product_element => {
      this.product_form_dict['total_price_per_order'] += this.product_form_dict['total_price_per_product_per_month'][product_element.product_id];
    });
    // add total price per session
    let total_cost_per_session = 0;
    this.product_form_dict['total_price_per_session'][session_id] = 0;
    this.product_list.forEach(product_element => {
      total_cost_per_session += this.product_form_dict['product'][session_id][product_element.product_id]['price'];
    });
    this.product_form_dict['total_price_per_session'][session_id] = total_cost_per_session;

    // add the total quantity per session
    let total_quantity_per_session = 0;
    this.product_form_dict['total_quantity_per_session'][session_id] = 0;
    this.product_list.forEach(product_element => {
      total_quantity_per_session += this.product_form_dict['product'][session_id][product_element.product_id]['quantity'];
    });
    this.product_form_dict['total_quantity_per_session'][session_id] = total_quantity_per_session;
  }

  async payClicked() {
    if (this.total_quantity > this.milk_limit) {
      alert('Max limit is reached please check the quantity');
      return false;
    }

    const dialogRef = this.dialog.open(IcustomerConfirmOrderComponent, {
      height: '500px',
      width: '600px',
      data: {
        'month_start_date': this.next_month_start_date_in_string,
        'product_form_data': this.product_form_dict,
        'total_days_in_month': this.total_days_in_next_month,
        'pincode': this.pincode,
        'wallet_balance': this.wallet_balance,
        'icustomer_id': this.icustomer_id
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      const res = result;
      if (res['is_compleated']) {
        this.disable_button = false;
        this.global.showSnakeBar('order saved success!');
        this.generateIcustomerCard(res['data']);
      }
    });
  }

  generateIcustomerCard(document) {
    const dialogRef = this.dialog.open(IcustomerCardPreviewComponent, {
      height: '700px',
      width: '700px',
      data: {
        'data': document,
      },
      // disableClose: true,
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      this.icustomer_verified = false;
      this.total_quantity = 0;
      this.icustomer_code = null;
      this.icustomer_mobile = null;
      this.serveCounteOrders();
      window.scrollTo(0, 0);
      setTimeout(() => document.getElementById('customer_code').focus(), 500);
      this.disable_button = false;
    });
  }

  customerCardClikced(order_details) {
    let data_dict = {
      'customer_code': order_details['icustomer_code'],
      'month': order_details['month'],
      'year': order_details['year']
    };
    this.httpService.customerCardPreview(data_dict).subscribe((data) => {
      console.log(data);
      const dialogRef = this.dialog.open(IcustomerCardPreviewComponent, {
        height: '700px',
        width: '700px',
        data: {
          'data': data,
        },
        // disableClose: true,
      });
      dialogRef.afterClosed().subscribe(result => {
      });
    }, (error) => {
      console.error(error);
    });
  }

  icustomerPesonalDetails() {
    const dialogRef = this.dialog.open(IcustomerPersonalDetailsComponent, {
      height: '550px',
      width: '600px',
      data: {
        'icustomer_id': this.icustomer_detail['icustomer_id']
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (result) {
        let data_dict = { 'icustomer_number': this.icustomer_mobile, 'icustomer_code': this.icustomer_code };
        this.httpService.checkIcustomerDetails(data_dict).subscribe((data) => {
          console.log(data);
          this.icustomer_detail = data;
        }, (error) => {
          console.error(error);
        });
      }
    });
  }

  getHistroy() {
    const data_dict = {
      'icustomer_id': this.icustomer_id,
      'from': 'portal',
      'data_for': 'future'
    };
    this.httpService.serveIcustomerHistory(data_dict).subscribe((data) => {
      console.log(data);
      this.future_order = data;
    }, (error) => {
      console.error(error);
    });
  }

  onPageTitleSelected(index) {
    if (this.selected_index === index) {
      this.selected_index = null;
    } else {
      this.selected_index = index;
    }
    // this.selected_heading_index = null;
  }

  routeToDetailPage(month_and_year, index) {
    this.onPageTitleSelected(index);
    this.selected_date = month_and_year['year'] + '-' + month_and_year['month'] + '-' + '01';
    this.serveCustomerFutureOrders();
    this.month_and_year = month_and_year;
  }

  async serveCustomerFutureOrders() {
    let data_dict = {
      'selected_date': this.selected_date,
      'from': 'portal',
      'icustomer_id': this.icustomer_id
    };
    this.httpService.serveSelectedMonthSaleForIcustomer(data_dict).subscribe((product_data) => {
      console.log(product_data);
      let date = new Date(this.selected_date);
      this.total_days_in_month = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
      this.product_form_dict_for_future_order = {};
      this.product_form_dict_for_future_order['product'] = {};
      this.product_form_dict_for_future_order['total_price_per_product_per_day'] = {};
      this.product_form_dict_for_future_order['total_price_per_product_per_month'] = {};
      this.product_form_dict_for_future_order['total_price_per_session'] = {};
      this.business_details_for_future = product_data['business_details']
      // this.product_form_dict_for_future_order['total_price_per_order'] = 0;
      this.session_list.forEach(session_element => {
        this.product_form_dict_for_future_order['product'][session_element.id] = {};
        if (product_data['product'].hasOwnProperty(session_element.id)) {
          this.product_list.forEach(product_element => {
            if (product_data['product'][session_element.id].hasOwnProperty(product_element.product_id)) {
              this.product_form_dict_for_future_order['product'][session_element.id][product_element.product_id] = product_data['product'][session_element.id][product_element.product_id]
            } else {
              this.product_form_dict_for_future_order['product'][session_element.id][product_element.product_id] = {
                'quantity': null,
                'price': 0
              };
            }
          });
        } else {
          // this.product_form_dict_for_future_order['total_price_per_session'][session_element.id] = 0;
          this.product_list.forEach(product_element => {
            this.product_form_dict_for_future_order['product'][session_element.id][product_element.product_id] = {
              'quantity': null,
              'price': 0
            };
          });
        }
        this.product_list.forEach(product_element => {
          if (product_data['total_price_per_product'].hasOwnProperty(product_element.product_id)) {
            this.product_form_dict_for_future_order['total_price_per_product_per_month'][product_element.product_id] = product_data['total_price_per_product'][product_element.product_id] * this.total_days_in_month;
          } else {
            this.product_form_dict_for_future_order['total_price_per_product_per_month'][product_element.product_id] = 0;
          }
        });
      });
      this.product_form_dict_for_future_order['total_price_per_order'] = 0;
      this.product_list.forEach(product_element => {
        this.product_form_dict_for_future_order['total_price_per_order'] += this.product_form_dict_for_future_order['total_price_per_product_per_month'][product_element.product_id];
      });
      console.log(this.product_form_dict_for_future_order);
    }, (error) => {
      console.error(error);
    });
  }

  async boothChangeClicked(page_action) {
    console.log('dialog open');
    const dialogRef = this.dialog.open(BoothChangeForOrderComponent, {
      height: '600px',
      width: '800px',
      data: {
        'pincode': this.icustomer_detail['pincode'],
        'user_profile_id': this.icustomer_detail['user_profile_id'],
        'page_action': page_action,
        'selected_date': this.month_and_year
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      const res = result;
      if (res) {
        if (page_action === 'edit') {
          this.serveBusinessDetails();
        } else {
          this.serveCustomerFutureOrders();
        }
      }
    });
  }

  deleteClicked(sale_details) {
    if (confirm('இந்த ஆர்டரை கண்டிப்பாக நீக்க வேண்டுமா?')) {
      console.log(sale_details);
      this.is_deteted = false;
      this.httpService.deleteSelectedIcustomerSale(sale_details).subscribe((data) => {
        console.log(data);
        this.serveCounteOrders();
        this.getIcustomerDetails();
        this.is_deteted = true;
      }, (error) => {
        this.is_deteted = true;
        console.error(error);
      });
    }
  }

  checkNextMonthOrder() {
    let customer_code_dict = {
      'customer_code': this.icustomer_code,
    }
    this.httpService.checkNextMonthOrder(customer_code_dict).subscribe((data) => {
      this.next_month_order_avaliable = data;
      console.log(this.next_month_order_avaliable)
    });
  }

  ngOnInit() {
  }

}
